import { render, staticRenderFns } from "./SettlementView.vue?vue&type=template&id=db4fb6a2&scoped=true&lang=pug"
import script from "./SettlementView.vue?vue&type=script&lang=ts"
export * from "./SettlementView.vue?vue&type=script&lang=ts"
import style0 from "./SettlementView.vue?vue&type=style&index=0&id=db4fb6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4fb6a2",
  null
  
)

export default component.exports